<template>
  <div class="topbar">
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="d-flex justify-content-between">
            <div class="logo d-inline-flex align-items-center">
              <router-link to="/">
                <img
                  :alt="getAppName"
                  class="d-inline-block"
                  height="30"
                  src="../assets/images/logo.png"
                />
                <!-- <p class="d-inline-block align-middle ml-2 mb-0 text" v-html="getAppTitle"></p> -->
              </router-link>
              <div class="boxjptop bv-d-md-down-none">
                <router-link to="/member/jackpot">
                  <small>ลุ้น Jackpot</small>
                  <span class="gold-text" id="odometer2">1,000,000</span>
                  <small>คลิก!!</small>
                </router-link>
              </div>
            </div>
            <div class="info d-inline-flex align-items-center">
              <span class="txt-money badge badge-light">
                <i class="fas fa-coins"></i>
                <span data-id="credit_balance" class="ml-2">{{getCashAmount.toFixed(2)}} ฿</span>
              </span>
              <a href="https://lin.ee/QG8Yl8H" target="_blank" class="iconmenu">
                <img src="../assets/images/call-line.png" alt="ติดต่อผ่านไลน์" height="25" width="25" />
              </a>
              <img
                src="../assets/images/defaultPerson.jpeg"
                alt="profile"
                class="d-inline img-fluid rounded pic-user"
                width="31"
                onerror="this.src='../assets/images/defaultPerson.jpeg'"
              />
              <div class="txt-user bv-d-sm-down-none">
                <small>สวัสดี!</small>
                <span>{{getUsername}}</span>
              </div>
              <v-select
                class="bv-d-sm-down-none rounded w-100 bg-white"
                v-model="selected"
                :options="options"
                :clearable="false"
                label="title"
              >
                <template v-slot:selected-option="option">
                  <img class="flag-icon mr-2" :src="option.cardImage" />
                  {{ option.title }}
                </template>
                <template slot="option" slot-scope="option">
                  <img class="flag-icon mr-2" :src="option.cardImage" />
                  {{ option.title }}
                </template>
              </v-select>
              <tasty-burger-button
                type="vortex"
                :size="'xs'"
                :color="'#ffffff'"
                :activeColor="'#ffffff'"
                :rounded="true"
                class="ml-2 rounded hamburger-menu"
                v-on:toggle="toggleMenu"
              />
              <div :class="['menu', menuVisible ? 'visible' : '']">
                <div>
                  <ul>
                    <li>
                      <img
                        :src="require('../assets/images/defaultPerson.jpeg')"
                        alt="username"
                        class="img-thumbnail"
                        width="120"
                        onerror="this.src='/assets/images/defaultPerson.jpeg'"
                      />
                    </li>
                    <li class="text-dark">
                      <b>{{getUsername}}</b>
                      <br />
                      <small>
                        <i class="fas fa-wallet"></i> Credit
                      </small>
                      <span class="badge badge-dark font-weight-normal pb-1 font-weight-bold">
                        <span data-id="credit_balance">{{getCashAmount.toFixed(2)}} ฿</span>
                      </span>
                      <br />
                    </li>
                    <div class="dropdown-divider"></div>
                    <li>
                      <router-link to="/member/settings/profile">ตั้งค่าบัญชีผู้ใช้</router-link>
                    </li>
                    <li v-if="getCustomerType != null && getCustomerType < 1">
                      <router-link to="/member/settings/bank">บัญชีธนาคาร</router-link>
                    </li>
                    <li v-if="getCustomerType != null && getCustomerType < 1">
                      <router-link to="/member/deposit">เติมเงิน</router-link>
                    </li>
                    <li>
                      <router-link to="/howto">วิธีใช้งาน</router-link>
                    </li>
                    <li>
                      <a href="https://lin.ee/QG8Yl8H" target="_blank">ศูนย์ช่วยเหลือ</a>
                    </li>
                    <li>
                      <v-select
                        class="rounded bg-white w-auto"
                        v-model="selected"
                        :options="options"
                        :clearable="false"
                        label="title"
                      >
                        <template v-slot:selected-option="option">
                          <img class="flag-icon mr-2" :src="option.cardImage" />
                          {{ option.title }}
                        </template>
                        <template slot="option" slot-scope="option">
                          <img class="flag-icon mr-2" :src="option.cardImage" />
                          {{ option.title }}
                        </template>
                      </v-select>
                    </li>
                    <div class="dropdown-divider"></div>
                    <li class="text-dark">
                      <a @click="logout">
                        <i class="fas fa-sign-out-alt"></i> ออกจากระบบ
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
// import hamburger from "vue-hamburgers";
// Vue.use(hamburger);

export default {
  name: "TopBarMember",
  data() {
    return {
      size: "s",
      selected: {
        title: "ไทย",
        cardImage: require("../assets/flags/4x3/th.svg")
      },
      options: [
        {
          title: "ไทย",
          cardImage: require("../assets/flags/4x3/th.svg")
        },
        // {
        //   title: "English",
        //   cardImage: require("../assets/flags/4x3/gb.svg")
        // },
        // {
        //   title: "ລາວ",
        //   cardImage: require("../assets/flags/4x3/la.svg")
        // }
      ],
      menuVisible: false,
      userInfo: []
    };
  },
  mounted() {
    this.checkAccessToken();
  },
  methods: {
    ...mapActions({
      revokeToken: "revokeToken",
      setCustomerType: "setCustomerType",
      setCashAmount: "setCashAmount",
      setRewardAmount: "setRewardAmount"
    }),
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    checkAccessToken() {
      if (
        this.getAccessToken === null ||
        this.getAccessToken === undefined
      ) {
        console.log('no access token');
        this.revokeToken();
        this.$router.push({ name: "Home" });
      }
      else {
        console.log('get token', this.getAccessToken, this.getUsername);
        const options = {
          url: this.getApiUrl + "/customer/getcurrentfinance",
          method: "POST",
          data: {
            "username": this.getUsername
          }
        };
        // axios.defaults.headers.common["Authorization"] = "Bearer " + this.getAccessToken;

        axios.post(this.getApiUrl + "/customer/getcurrentfinance",
          {
            username: this.getUsername
          },
          {
            headers: {
              "Content-Type": "application/json",
              "token": this.getAccessToken,
              "username": this.getUsername
            }
          } )
          .then(response => {
            console.log(response);
            if(response.data.statusCode == 200) {
              this.userInfo = response.data.data;
              this.setCustomerType(response.data.data.type);
              this.setCashAmount(response.data.data.cashAmount);
              this.setRewardAmount(response.data.data.jackpotCredit);
            }
            else {
              this.logout();
            }
          });
      }
    },
    logout() {
        console.log('logged out');
        this.revokeToken();
        this.$router.push({ name: "Home" });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getCustomerType: "getCustomerType",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl",
      getAppTitle: "getAppTitle",
      getAppName: "getAppName"
    })
  }
}
</script>

<style lang="scss" scoped>
.topbar {
  width: 100%;
  min-height: 30px;
  padding: 5px 0;
  box-shadow: 0 1px #000;
  display: block;
  float: left;
  line-height: 0;
  background: url(../assets/images/gold-white.jpg) top center;
  background-size: 100%;

  .hamburger-menu {
    padding: 0.6em 1em;
    background: rgba(63, 62, 55, 0.75) !important;
    z-index: 99;
  }

  .container {
    font-family: Sukhumvit;
  }

  .visible {
    visibility: visible !important;
  }

  .menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: 1px solid transparent;
    background: rgba(255, 187, 0, 0.97);
    visibility: hidden;
    z-index: 98;
    display: flex;
    align-items: center;
    justify-content: center;

    .badge {
      text-shadow: none !important;
    }

    > div {
      max-height: 100vh;
      // flex:;

      > ul {
        list-style: none;
        padding: 0 1em;
        margin: 0 auto;
        display: block;
        max-height: 100vh;
        width: 200px;
        text-shadow: rgb(255 214 103) 1px 1px 0;

        > li {
          padding: 0;
          line-height: 2em;
          font-size: 18px;
          display: block;
          text-align: center;

          > a {
            position: relative;
            display: inline;
            cursor: pointer;
            color: #000;
          }
        }
      }
    }
  }

  .logo {
    a {
      vertical-align: middle;
      color: black;
      text-decoration: none;
      line-height: 0;
      text-shadow: goldenrod 0px 1px 0;
      font-family: SukhumvitBold;
      font-size: 25px;

      .text88 {
        color: white !important;
        text-shadow: 0px 0px 2px gray;
        font-size: 108%;
        margin-left: -5px;
      }
    }

    @media (max-width: 460px) {
      a {
        font-size: 20px !important;

        .text88 {
          font-size: 108%;
        }
      }
    }

    @media (max-width: 425px) {
      a {
        font-size: 17px !important;

        .text88 {
          font-size: 108%;
        }
      }
    }

    .text {
      @media (max-width: 415px) {
        display: none !important;
      }
    }
  }

  .info {
    .txt-money {
      line-height: 1.2;
      margin-right: 5px;
      background: rgba(78, 75, 63, 0.9);
      border: goldenrod 1px solid;
      border: rgba(71, 69, 64, 0.815) 1px solid;
      color: white;
      font-weight: 700;
      vertical-align: middle;
      padding-bottom: 1px;
      font-size: 110%;
    }

    .iconmenu {
      margin: 0 5px;
      text-shadow: gold 1px 1px 0;

      img {
        width: 30px;
        height: 30px;
      }
    }

    .pic-user {
      margin-right: 5px;
      margin-left: 5px;
      border: rgba(71, 69, 64, 0.815) 1px solid;
    }

    .txt-user {
      margin-right: 10px;
      font-size: 120%;
      vertical-align: middle;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      width: auto;
      padding-top: 10px;
      line-height: 1.2;
      color: white;
      text-shadow: hsl(50deg 87% 9%) 1px 1px 0;

      small {
        font-size: 60%;
        display: block;
        line-height: 0;
        margin-top: 5px;
        color: black;
        text-shadow: none;
      }
    }

    .flag-icon {
      background-size: contain;
      background-position: 50%;
      background-repeat: no-repeat;
      position: relative;
      display: inline-block;
      width: 1.33333333em;
      line-height: 1em;
    }
  }

  .boxjptop {
    border: rgba(213, 173, 109, 1) 1px solid;
    box-shadow: rgb(213 173 109) 0 0 3px;
    animation: boxjp 0.5s;
    -moz-animation: boxjp 0.5s infinite;
    -webkit-animation: boxjp 0.5s infinite;
    color: white;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 10px;
    background: #343a40;
    font-size: 25px;
    margin-left: 5px;
    line-height: 1.5;

    a {
      line-height: 1.2;
      color: inherit;
      text-decoration: none;
      background-color: transparent;

      small {
        margin: 0 5px;
        font-size: 60%;
        vertical-align: middle;
        font-family: "Sriracha", cursive;
        margin-right: 5px;
        font-weight: 400;
      }

      span {
        line-height: 1.2;
        font-family: SukhumvitBold;
        vertical-align: middle;
      }

      .gold-text {
        color: #d5ad6d;
        background: -webkit-linear-gradient(transparent, transparent),
          -webkit-linear-gradient(top, #d5ad6d 0%, #d5ad6d 26%, #e2ba78 35%, #a37e43
                45%, #91703b 61%, #d5ad6d 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}

@-moz-keyframes boxjp /* Firefox */ {
  0% {
    box-shadow: rgba(213, 173, 109, 1) 0 0 8px;
  }
  50% {
    box-shadow: rgba(213, 173, 109, 0) 0 0 3px;
  }
  100% {
    box-shadow: rgba(213, 173, 109, 1) 0 0 8px;
  }
}

@-webkit-keyframes boxjp /* Safari and Chrome */ {
  0% {
    box-shadow: rgba(213, 173, 109, 1) 0 0 8px;
  }
  50% {
    box-shadow: rgba(213, 173, 109, 0) 0 0 3px;
  }
  100% {
    box-shadow: rgba(213, 173, 109, 1) 0 0 8px;
  }
}
</style>
